export type TimingKind = "phase" | "model_stage" | "tool" | "step" | "run";

/** Human-readable labels for each TimingKind value. */
export const TIMING_KIND_LABELS: Record<TimingKind, string> = {
  model_stage: "Model stage",
  phase: "Phase",
  run: "Run",
  step: "Step",
  tool: "Tool",
};

export type TimingEntryOrder = "asc" | "desc";

export interface TimingSummaryTotals {
  count: number;
  totalDurationMs: number;
  avgDurationMs: number | null;
  minDurationMs: number | null;
  maxDurationMs: number | null;
}

export interface TimingWindow {
  fromTimestampMs: number;
  toTimestampMs: number;
}

export interface TimingSummaryResponse {
  window: TimingWindow;
  totals: TimingSummaryTotals;
}

export interface TimingEntry {
  id: string;
  task_id: string;
  ticket_id: string | null;
  stream_id: string | null;
  kind: TimingKind;
  name: string | null;
  duration_ms: number;
  started_at: number | null;
  ended_at: number | null;
  step_number: number | null;
  run_id: string | null;
  payload: unknown;
  created_at: number;
}

export interface TimingEntriesResponse {
  page: number;
  pageSize: number;
  total: number;
  offset: number;
  order: TimingEntryOrder;
  entries: TimingEntry[];
}

export interface TimingFilters {
  fromTimestampMs?: number;
  toTimestampMs?: number;
  taskId?: string;
  ticketId?: string;
  streamId?: string;
  runId?: string;
  kinds?: TimingKind[];
  names?: string[];
  stepNumber?: number;
  minDurationMs?: number;
  maxDurationMs?: number;
}
